import { render } from "./d-prediction-1.vue?vue&type=template&id=0c83a472&scoped=true&ts=true"
import script from "./d-prediction-1.vue?vue&type=script&lang=ts"
export * from "./d-prediction-1.vue?vue&type=script&lang=ts"

import "./d-prediction-1.vue?vue&type=style&index=0&id=0c83a472&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c83a472"]])

export default __exports__